import React from 'react'
import { Link, useLocation } from 'react-router-dom'

function Booking({tab, handleOpenTab, titleTag}) {
    const location = useLocation();
  return (
      <div className='booking-page__tab'>
              <Link to={'/booking'} className={location.pathname === '/booking' && (!tab || titleTag === '_online') ? 'link active' : 'link'} onClick={() => handleOpenTab('Запись')}>Запись</Link>
              <Link to={'/booking/request'} className={(location.pathname === '/booking/request' && (!tab || titleTag === '_request')? 'link active two' : 'link two')} onClick={() => handleOpenTab('Мои заявки')}>Мои заявки</Link>
      </div>
  )
}

export default Booking